import useNavRoutes from "@usas/ui-web/state/security/UseNavRoutes";
import { useNavigate } from "@usas/ui-web/wrappers/ReactRouterDom";

const useRow = (queue) => {
  const navigate = useNavigate();
  const { navRoutes } = useNavRoutes();

  const onClick = (e, isRevisit) => {
    e?.preventDefault();

    if (navRoutes[queue.routeName]?.route) {
      navigate(navRoutes[queue.routeName].route, { state: { isRevisit: isRevisit } });
    }
  };

  return {
    onClick
  };
};

export default useRow;